module.exports = __webpack_public_path__ + "img/51.d645b4de.svg";